import styled from 'styled-components';
import { DialogType } from './types';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: ${({ theme }) => theme.white};
  box-shadow: 0 0 12px ${({ theme }) => theme.white === '#1a1a1a' ? 'rgba(255, 255, 255, 0.25)' : theme.darkColor};
  padding: 24px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const IconContainer = styled.div<{ type: DialogType }>`
  color: ${({ type, theme }) => {
    switch (type) {
      case 'success':
        return theme.successColor;
      case 'error':
        return theme.errorColor;
      case 'confirm':
        return theme.warningColor;
    }
  }};
  font-size: 48px;
`;

export const Message = styled.p`
  margin: 0;
  text-align: center;
  font-size: 0.95rem;
  color: ${({ theme }) => theme.darkColor};
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  width: 100%;
`;

const BaseButton = styled.button`
  padding: 8px 24px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  font-size: 1rem;
  transition: all 0.2s;
  outline: none;

  &:focus {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.white}, 0 0 0 4px currentColor;
  }
`;

export const CloseButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.darkColorLight};
  color: ${({ theme }) => theme.white};
  padding: 8px 32px;

  &:hover {
    background-color: ${({ theme }) => theme.darkColorLightHover};
  }
`;

export const CancelButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.errorColor};
  color: ${({ theme }) => theme.white};

  &:hover {
    background-color: ${({ theme }) => theme.errorColorHover};
  }
`;

export const ConfirmButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.successColor};
  color: ${({ theme }) => theme.white};

  &:hover {
    background-color: ${({ theme }) => theme.successColorHover};
  }
`;
